import { FONT_BASE } from '../../constants/AppFonts';

export class StageStartDisplay extends Phaser.GameObjects.Container {
  constructor(scene, opts = {}) {
    super(scene);
    scene.add.existing(this);
    this.setScrollFactor(0);
    this.add([
      scene.add.image(840, 360, 'overlay_purple'),
      scene.add.image(840, 360, 'graphics', 'overlay_panel_blue'),
      scene.add.image(840, 202, 'locale_text', 'title_stagestart'),
      scene.add.image(840, 396, 'graphics', 'stage_panel'),
      scene.add.image(590, 720, 'character_thumbs', 'char_pose_' + opts.heroid).setOrigin(1),
    ]);

    const current = scene.add.image(840, 396, 'graphics', 'stage_panel_active');
    switch (opts.stageInfo.stage) {
      case 3:
        current.x = 990;
        break;
      case 2:
        current.x = 841;
        break;
      default:
        current.x = 694;
        break;
    }

    this.add([
      current,
      this._createText(
        696,
        396,
        opts.stageInfo.level + '-1',
        opts.stageInfo.stage === 1 ? '#000045' : '#FFFFFF'
      ),
      this._createText(
        845,
        396,
        opts.stageInfo.level + '-2',
        opts.stageInfo.stage === 2 ? '#000045' : '#FFFFFF'
      ),
      this._createText(
        994,
        396,
        opts.stageInfo.level + '-3',
        opts.stageInfo.stage === 3 ? '#000045' : '#FFFFFF'
      ),
    ]);
  }

  _createText(x, y, value, colour) {
    return this.scene.add
      .text(x, y, value, {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 36,
        align: 'center',
        color: colour,
      })
      .setOrigin(0.5);
  }
}
